import AAVE from '@/assets/img/coin/aave.png';
import ADA from '@/assets/img/coin/ada.png';
import AGLD from '@/assets/img/coin/agld.png';
import ALGO from '@/assets/img/coin/algo.png';
import ALICE from '@/assets/img/coin/alice.png';
import ARB from '@/assets/img/coin/arb.png';
import ATOM from '@/assets/img/coin/atom.png';
import AVAX from '@/assets/img/coin/avax.png';
import AXS from '@/assets/img/coin/axs.png';
import BAT from '@/assets/img/coin/bat.png';
import BCH from '@/assets/img/coin/bch.png';
import BIT from '@/assets/img/coin/bit.png';
import BNB from '@/assets/img/coin/bnb.png';
import BNBBEP20 from '@/assets/img/coin/bnbbep20.png';
import BNX from '@/assets/img/coin/bnx.png';
import BSC from '@/assets/img/coin/bsc.png';
import BTC from '@/assets/img/coin/btc.png';
import BTT from '@/assets/img/coin/btt.png';
import BUSDT from '@/assets/img/coin/busdt.png';
import CAKE from '@/assets/img/coin/cake.png';
import CELR from '@/assets/img/coin/celr.png';
import CHR from '@/assets/img/coin/chr.png';
import CHZ from '@/assets/img/coin/chz.png';
import COMP from '@/assets/img/coin/comp.png';
import CLV from '@/assets/img/coin/clv.png';
import CRO from '@/assets/img/coin/cro.png';
import CRV from '@/assets/img/coin/crv.png';
import CVP from '@/assets/img/coin/cvp.png';
import DAI from '@/assets/img/coin/dai.png';
import DODO from '@/assets/img/coin/dodo.png';
import DOGE from '@/assets/img/coin/doge.png';
import DOT from '@/assets/img/coin/dot.png';
import DYDX from '@/assets/img/coin/dydx.png';
import EGLD from '@/assets/img/coin/egld.png';
import ENJ from '@/assets/img/coin/enj.png';
import EOS from '@/assets/img/coin/eos.png';
import ERN from '@/assets/img/coin/ern.png';
import ETC from '@/assets/img/coin/etc.png';
import ETH from '@/assets/img/coin/eth.png';
import FIL from '@/assets/img/coin/fil.png';
import FTM from '@/assets/img/coin/ftm.png';
import FTT from '@/assets/img/coin/ftt.png';
import GALA from '@/assets/img/coin/gala.png';
import GHST from '@/assets/img/coin/ghst.png';
import GRT from '@/assets/img/coin/grt.png';
import HECO from '@/assets/img/coin/heco.png';
import HOT from '@/assets/img/coin/hot.png';
import HT from '@/assets/img/coin/ht.png';
import IMX from '@/assets/img/coin/imx.png';
import IOTX from '@/assets/img/coin/iotx.png';
import KSM from '@/assets/img/coin/ksm.png';
import LDO from '@/assets/img/coin/ldo.png';
import LINCH from '@/assets/img/coin/linch.png';
import LINK from '@/assets/img/coin/link.png';
import LRC from '@/assets/img/coin/lrc.png';
import LTC from '@/assets/img/coin/ltc.png';
import MANA from '@/assets/img/coin/mana.png';
import MASK from '@/assets/img/coin/mask.png';
import MATIC from '@/assets/img/coin/matic.png';
import MBOX from '@/assets/img/coin/mbox.png';
import MDX from '@/assets/img/coin/mdx.png';
import MKR from '@/assets/img/coin/mkr.png';
import NEAR from '@/assets/img/coin/near.png';
import OMG from '@/assets/img/coin/omg.png';
import OP from '@/assets/img/coin/op.png';
import PLA from '@/assets/img/coin/pla.png';
import QNT from '@/assets/img/coin/qnt.png';
import RARE from '@/assets/img/coin/rare.png';
import RNDR from '@/assets/img/coin/rndr.png';
import SAND from '@/assets/img/coin/sand.png';
import SHIB from '@/assets/img/coin/shib.png';
import SLP from '@/assets/img/coin/slp.png';
import SOL from '@/assets/img/coin/sol.png';
import SRM from '@/assets/img/coin/srm.png';
import SUSHI from '@/assets/img/coin/sushi.png';
import TLM from '@/assets/img/coin/tlm.png';
import TRX from '@/assets/img/coin/trx.png';
import TUSDT from '@/assets/img/coin/tusdt.png';
import UNI from '@/assets/img/coin/uni.png';
import USDC from '@/assets/img/coin/usdc.png';
import USDT from '@/assets/img/coin/usdt.png';
import VENTHOR from '@/assets/img/coin/venthor.png';
import VET from '@/assets/img/coin/vet.png';
import XLM from '@/assets/img/coin/xlm.png';
import XRP from '@/assets/img/coin/xrp.png';
import YFII from '@/assets/img/coin/yfii.png';
import ZEC from '@/assets/img/coin/zec.png';
import CNY from '@/assets/img/coin/CNY.png';

export default {
  SOL,
  ATOM,
  XLM,
  BNB,
  MATIC,
  UNI,
  LINK,
  BTC,
  ETH,
  ETC,
  LTC,
  EOS,
  BCH,
  TRX,
  DOT,
  DOGE,
  SHIB,
  XRP,
  USDT,
  AAVE,
  ADA,
  ALGO,
  ALICE,
  AXS,
  BAT,
  BIT,
  BNX,
  BTT,
  AGLD,
  BSC,
  FIL,
  MANA,
  VET,
  NEAR,
  AVAX,
  LDO,
  IMX,
  GRT,
  USDC,
  RNDR,
  SAND,
  ZEC,
  YFII,
  VENTHOR,
  TUSDT,
  TLM,
  SUSHI,
  SRM,
  SLP,
  RARE,
  QNT,
  PLA,
  OP,
  OMG,
  MKR,
  MDX,
  MBOX,
  MASK,
  LRC,
  LINCH,
  KSM,
  IOTX,
  HT,
  HOT,
  HECO,
  GHST,
  GALA,
  FTT,
  FTM,
  ERN,
  ENJ,
  EGLD,
  DYDX,
  DODO,
  DAI,
  CVP,
  CRV,
  CRO,
  COMP,
  CLV,
  CHZ,
  CHR,
  CELR,
  CAKE,
  BUSDT,
  BNBBEP20,
  ARB,
  CNY
};
